// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2wKAr","label":"SetPasswdForm_label__3kBNj"};